import { nanoid } from 'nanoid';

type Entity = 'form' | 'applicant' | 'resume' | 'coupon';

const LENGTH = 12;
const PREFIXES: Record<Entity, string> = {
  form: 'frm',
  applicant: 'apl',
  resume: 'rsm',
  coupon: 'cpn'
};

export default function generateUUID(entity: Entity) {
  const id = nanoid(LENGTH);
  const prefix = PREFIXES[entity];
  return `${prefix}_${id}`;
}